var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.gameState.inStatusModal
    ? _c(
        "div",
        { staticClass: "status-modal", on: { click: _vm.closeModal } },
        [
          _c(
            "div",
            {
              staticClass: "status-card",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "status-content" }, [
                _c("div", { staticClass: "character-section" }, [
                  _c("div", { staticClass: "character-info-row" }, [
                    _c("span", { staticClass: "character-name" }, [
                      _vm._v(_vm._s(_vm.gameState.name)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "spiritual-root-name",
                        class: _vm.spiritualRootClass,
                      },
                      [_vm._v(_vm._s(_vm.gameState.spiritualRoot.name))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "character-sect" }, [
                      _vm._v(_vm._s(_vm.gameState.sect)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "character-location" }, [
                      _vm._v(_vm._s(_vm.gameState.location)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "realm-progress-section" }, [
                    _c("div", { staticClass: "realm-display" }, [
                      _c("span", { staticClass: "realm-text" }, [
                        _vm._v(
                          _vm._s(_vm.realmName) + _vm._s(_vm.substageName)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "period-text" }, [
                        _vm._v("(" + _vm._s(_vm.periodName) + ")"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "realm-bar" }, [
                      _c("div", {
                        staticClass: "realm-fill",
                        style: { width: _vm.progressPercent + "%" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "realm-value" }, [
                        _vm._v(
                          _vm._s(_vm.gameState.xp) + "/" + _vm._s(_vm.xpToLevel)
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stats-section" }, [
                  _c("div", { staticClass: "stat-row" }, [
                    _c("div", { staticClass: "stat-item" }, [
                      _c("div", { staticClass: "stat-label-row" }, [
                        _c("span", { staticClass: "stat-label" }, [
                          _vm._v("气血"),
                        ]),
                        _vm._v(" "),
                        _vm.injuryType
                          ? _c(
                              "span",
                              {
                                staticClass: "status-badge",
                                class:
                                  _vm.injuryType === "重伤"
                                    ? "severe-injury-badge"
                                    : "injury-badge",
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.injuryType) +
                                    "\n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-value" }, [
                          _vm._v(
                            _vm._s(_vm.gameState.qi) +
                              "/" +
                              _vm._s(_vm.effectiveMaxQi)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-bar" }, [
                        _c("div", {
                          staticClass: "stat-fill qi-fill",
                          style: { width: _vm.qiPercent + "%" },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm.hasInjury
                        ? _c("div", { staticClass: "injury-info" }, [
                            _c("span", { staticClass: "injury-text" }, [
                              _vm._v(
                                "原始上限: " +
                                  _vm._s(
                                    _vm.gameState.originalMaxQi ||
                                      _vm.gameState.maxQi
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "injury-reduction" }, [
                              _vm._v("(-" + _vm._s(_vm.injuryReduction) + ")"),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-item" }, [
                      _c("div", { staticClass: "stat-label-row" }, [
                        _c("span", { staticClass: "stat-label" }, [
                          _vm._v("灵力"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-value" }, [
                          _vm._v(
                            _vm._s(_vm.gameState.mana) +
                              "/" +
                              _vm._s(_vm.maxMana)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-bar" }, [
                        _c("div", {
                          staticClass: "stat-fill mana-fill",
                          style: { width: _vm.manaPercent + "%" },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-row" }, [
                    _c("div", { staticClass: "stat-item" }, [
                      _c("span", { staticClass: "stat-label" }, [
                        _vm._v("攻击"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.gameState.attack)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-item" }, [
                      _c("span", { staticClass: "stat-label" }, [
                        _vm._v("防御"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.gameState.defense)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-row" }, [
                    _c("div", { staticClass: "stat-item" }, [
                      _c("span", { staticClass: "stat-label" }, [
                        _vm._v("神识"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.gameState.divineSenseStrength)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(1),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "refining-section" }, [
                  _c("h4", [_vm._v("炼丹炼器")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "refining-list" }, [
                    _c("div", { staticClass: "refining-item" }, [
                      _c("span", { staticClass: "refining-name" }, [
                        _vm._v("炼丹等级"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "refining-level" }, [
                        _vm._v(_vm._s(_vm.pillRefiningLevelName)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "refining-item" }, [
                      _c("span", { staticClass: "refining-name" }, [
                        _vm._v("炼器等级"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "refining-level" }, [
                        _vm._v(_vm._s(_vm.treasureRefiningLevelName)),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "realm-system-section" }, [
                  _c("h4", [_vm._v("境界系统")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "realm-progress" },
                    _vm._l(_vm.realmNames, function (realm) {
                      return _c(
                        "div",
                        {
                          key: realm.name,
                          staticClass: "realm-item",
                          class: {
                            "current-realm":
                              realm.index === _vm.gameState.realm,
                          },
                        },
                        [
                          _c("div", { staticClass: "realm-name" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(realm.name) +
                                "境界\n              "
                            ),
                            realm.index === _vm.gameState.realm
                              ? _c("span", { staticClass: "current-marker" }, [
                                  _vm._v("(当前)"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          realm.index === _vm.gameState.realm
                            ? _c(
                                "div",
                                { staticClass: "substage-progress" },
                                _vm._l(_vm.substages, function (substage) {
                                  return _c(
                                    "div",
                                    {
                                      key: substage.index,
                                      staticClass: "substage-item",
                                      class: {
                                        "current-substage":
                                          substage.index ===
                                          _vm.gameState.substage,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "substage-name" },
                                        [
                                          _vm._v(
                                            _vm._s(substage.name) +
                                              "(" +
                                              _vm._s(substage.period) +
                                              ")"
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      substage.index === _vm.gameState.substage
                                        ? _c(
                                            "div",
                                            { staticClass: "progress-bar" },
                                            [
                                              _c("div", {
                                                staticClass: "progress-fill",
                                                style: {
                                                  width:
                                                    _vm.progressPercent + "%",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "progress-text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.gameState.xp) +
                                                      "/" +
                                                      _vm._s(_vm.xpToLevel)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : substage.index <
                                          _vm.gameState.substage
                                        ? _c(
                                            "div",
                                            { staticClass: "completed" },
                                            [_vm._v("已完成")]
                                          )
                                        : _c("div", { staticClass: "locked" }, [
                                            _vm._v("未解锁"),
                                          ]),
                                    ]
                                  )
                                }),
                                0
                              )
                            : realm.index < _vm.gameState.realm
                            ? _c("div", { staticClass: "realm-completed" }, [
                                _vm._v(
                                  "\n              ✓ 已完成 (累计修为: " +
                                    _vm._s(_vm.getRealmTotalXp(realm.index)) +
                                    ")\n            "
                                ),
                              ])
                            : _c("div", { staticClass: "realm-locked" }, [
                                _vm._v("✗ 未解锁"),
                              ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _vm.gameState.inForbiddenMap
                  ? _c("div", { staticClass: "forbidden-section" }, [
                      _c("h4", [_vm._v("禁地信息")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "forbidden-info" }, [
                        _c("div", { staticClass: "forbidden-item" }, [
                          _c("span", { staticClass: "forbidden-label" }, [
                            _vm._v("位置:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "forbidden-value" }, [
                            _vm._v(
                              "(" +
                                _vm._s(_vm.gameState.playerPos.x) +
                                ", " +
                                _vm._s(_vm.gameState.playerPos.y) +
                                ")"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "forbidden-item" }, [
                          _c("span", { staticClass: "forbidden-label" }, [
                            _vm._v("进度:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "forbidden-value" }, [
                            _vm._v(
                              _vm._s(_vm.exploredCount) +
                                "/" +
                                _vm._s(_vm.totalCells)
                            ),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "status-footer" }, [
                _c(
                  "button",
                  { staticClass: "close-btn", on: { click: _vm.closeModal } },
                  [_vm._v("关闭")]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "status-header" }, [
      _c("h3", [_vm._v("角色状态")]),
      _vm._v(" "),
      _c("p", [_vm._v("修炼之路漫漫，勇往直前！")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-item" }, [
      _c("span", { staticClass: "stat-label" }, [_vm._v("暴击")]),
      _vm._v(" "),
      _c("span", { staticClass: "stat-value" }, [_vm._v("5%")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }